import { useContext } from "react";

import { useTranslation } from "react-i18next";
import { Link as RouterLink } from "react-router";

import { css } from "@emotion/react";

import TextLink, {
    TEXT_LINK_SIZES
} from "components/DesignComponents/TextLink";
import AuthContext from "context/auth/authContext";
import { ROUTES } from "shared";

const ForgotPasswordLink = () => {
    const { removeMessage } = useContext(AuthContext);
    const { t } = useTranslation();

    return (
        <TextLink
            component={RouterLink}
            to={ROUTES.RequestReset}
            size={TEXT_LINK_SIZES.Normal}
            onClick={removeMessage}
            css={css({
                margin: "4px 0 16px 0"
            })}
        >
            {t("Auth##forgot password")}
        </TextLink>
    );
};

export default ForgotPasswordLink;
